import { resolveImage as n, resolveLink as i } from "../../../helpers/index.js";
const p = (e) => e && e.length > 0 ? e.map((r) => ({
  variant: "transparent",
  date: r.content.properties?.date ? new Date(r.content.properties?.date) : void 0,
  venueName: r.content.properties?.venueName,
  venueAddress: r.content.properties?.venueAddress,
  link: r.content.properties?.signupPage && i(r.content.properties?.signupPage),
  deadline: r.content.properties?.deadline ? new Date(r.content.properties?.deadline) : void 0,
  duration: r.content.properties?.time,
  active: !0
})) : [], o = (e) => e.properties && Object.prototype.hasOwnProperty.call(e.properties, "isActive") ? {
  editLink: void 0,
  image: e.properties?.image?.[0] && n(e.properties?.image, !0),
  heading: e.properties?.header,
  description: e.properties?.teaser,
  occurences: p(e.properties?.events?.items),
  leftCta: e.properties?.signUpLink && i(e.properties?.signUpLink),
  rightCta: e.properties?.programLink && i(e.properties?.programLink),
  variant: "event",
  active: e.properties?.isActive,
  inactiveDescription: e.properties?.inactiveInfo
} : {
  editLink: void 0,
  image: e.properties?.image?.[0] && n(e.properties?.image, !0, "banner"),
  heading: e.properties?.header,
  description: e.properties?.teaser,
  link: e.properties?.link && i(e.properties?.link),
  variant: "simple"
};
export {
  o as heroDeliveryApiParser
};
